<template>
  <div
      class="lp-segmented"
      role="group">
    <button
        v-tooltip="option.tooltip || ''"
        v-for="option in options"
        :key="String(option.value)"
        :class="{ 'is-active': isActive(option) }"
        :disabled="option.disabled"
        :aria-pressed="isActive(option) ? 'true' : 'false'"
        type="button"
        class="lp-segmented__item"
        @click="select(option)">
      <icon
          v-if="option.icon"
          :name="option.icon"/>
      <span v-if="option.label">{{ option.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name:  'SegmentedControl',
  props: {
    options:  { type: Array, required: true },
    value:    { type: [String, Number, Boolean, Array], default: null },
    multiple: { type: Boolean, default: false },
  },
  methods: {
    isActive(option) {
      if (this.multiple) {
        return Array.isArray(this.value) && this.value.indexOf(option.value) !== -1;
      }
      return this.value === option.value;
    },
    select(option) {
      if (option.disabled) {
        return;
      }
      let next = option.value;
      if (this.multiple) {
        const current = Array.isArray(this.value) ? this.value : [];
        next          = this.isActive(option)
          ? current.filter(value => value !== option.value)
          : current.concat(option.value);
      }
      this.$emit('click', option);
      this.$emit('input', next);
      this.$emit('change', next);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-segmented {
  display: flex;
  gap: 2px;
  padding: 3px;
  border-radius: $lp-radius-control;
  background-color: $lp-fill;
}

.lp-segmented__item {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  height: 30px;
  padding: 0 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-family: $lp-sans;
  font-size: $lp-fs-control;
  color: $lp-ink-2;
  cursor: pointer;

  &:hover:not(:disabled) {
    color: $lp-ink;
  }

  &.is-active {
    background-color: $white;
    box-shadow: 0 1px 2px rgba(20, 22, 27, 0.1);
    font-weight: 600;
    color: $lp-accent;

    // Icons hard-code #3F3F3F or use currentColor on the <svg> itself: paint both in the accent colour
    ::v-deep svg {
      color: $lp-accent;

      &[stroke]:not([stroke="none"]),
      [stroke]:not([stroke="none"]) {
        stroke: currentColor;
      }

      &[fill]:not([fill="none"]),
      [fill]:not([fill="none"]) {
        fill: currentColor;
      }
    }
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  ::v-deep .icon {
    min-width: 0;
    min-height: 0;
  }
}
</style>
